import { selectProvider } from "@shared/actions/games";
import {
  useComputedProviders,
  useCurrentProviderId,
} from "@shared/hooks/games/game-providers";
import { useIsAuth } from "@shared/hooks/user";
import cx from "classnames";
import React, { memo, useCallback } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

const Navigation = () => {
  const currentProviderId = useCurrentProviderId();
  const computedProviders = useComputedProviders();
  const isAuth = useIsAuth();
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const handleProviderClick = useCallback(
    (event) => {
      const id = Number.parseInt(event.target.dataset.id, 10);
      const provider = computedProviders.find((provider) => provider.id === id);

      if (provider === undefined) {
        return;
      }

      if (provider.games_count === 1) {
        if (!isAuth) {
          history.push("/", { showAuthModal: true });
          return;
        }
        if (!provider.game) {
          return;
        }

        dispatch(selectProvider(id));
        history.push(`/games/${provider.game}`);
        return;
      }
      dispatch(selectProvider(id));
      document.querySelector(".lobby")?.scrollIntoView({ behavior: "smooth" });
      if (location.pathname !== "/") {
        history.push("/");
      }
    },
    [computedProviders, isAuth, location.pathname, dispatch, history]
  );

  if (!Array.isArray(computedProviders)) {
    return <div className="main-nav" role="menu" />;
  }

  return (
    <div className="main-nav" role="menu">
      {computedProviders.map((provider) => (
        <span
          style={{ display: !provider.games_count ? "none" : "" }}
          className={cx("main-nav__link", {
            active: currentProviderId === provider.id,
          })}
          onClick={handleProviderClick}
          data-id={provider.id}
          key={provider.id}
          role="menuitem"
        >
          {intl.formatMessage({
            id: provider.name,
            defaultMessage: provider.name,
          })}
        </span>
      ))}
    </div>
  );
};

export default memo(Navigation);
